import React, { useEffect, useMemo, useState } from "react";
import Chart from "react-apexcharts";
import { Card } from "react-bootstrap";
import analyticsService from "../../redux/services/analytics.service";

const EarningsBreakdown = ({ from, to, storeId }) => {
  const [loading, setLoading] = useState(true);
  const [totals, setTotals] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      try {
        const res = await analyticsService.overview({ from, to, storeId });
        const d = res.data?.data ?? res.data;
        if (!alive) return;
        setTotals(d?.totals ?? null);
      } catch {
        if (!alive) return;
        setTotals(null);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [from, to, storeId]);

  const options = useMemo(
    () => ({
      labels: ["Platform earning", "Discount total", "Refund amount", "Earning lost (discount)"],
      legend: { position: "bottom" },
    }),
    []
  );

  const series = useMemo(() => {
    const platformEarning = Number(totals?.platformEarning ?? 0) || 0;
    const discountTotal = Number(totals?.discountTotal ?? 0) || 0;
    const refundAmount = Number(totals?.refundAmount ?? 0) || 0;
    const earningLost = Number(totals?.earningLostDueToDiscount ?? 0) || 0;
    return [platformEarning, discountTotal, refundAmount, earningLost];
  }, [totals]);

  return (
    <Card className="mb-4 shadow-sm">
      <Card.Body>
        <div className="small text-muted mb-2">{loading ? "Loading…" : "Earnings breakdown"}</div>
        <Chart options={options} series={series} type="donut" height={300} />
      </Card.Body>
    </Card>
  );
};

export default EarningsBreakdown;
